<template>
  <div v-if="from == 'selectList'" style="width: 100%">
    <outputSelect :selectedAccount="selectedAccount" @AccountSelectInfo="AccountSelectInfo" :otherParam="otherParam"  :disabled="disabled"/>
  </div>
  <div v-else-if="from == 'pushStatus'" style="width: fit-content">
    <pushStatus v-if="mediaLoaded"></pushStatus>
  </div>
  <div v-else id="mediaOutputList" :class="{'headerOutputList': from != 'workbench'}"></div>
</template>
<script>
import outputSelect from '@/components/common/outputSelect.vue'
import pushStatus from '@/components/common/pushStatus.vue'
import { loadMediaJs } from '@/assets/js/loadSudoku.js'
import Outil from '@/assets/js/utils.js'
import { mapState } from 'vuex'
export default {
  props: {
    from: {
      type: String,
      default: 'workbench'
    },
    // program信息
    ProgramItem: {
      type: Object,
      default: () => null
    },
    // 选择的值
    selectedAccount: {
      type: Array,
      default: () => []
    },
    otherParam: {
      type: Object,
      default: () => {
        return { isMultiple: 1 }
      }
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mediaLoaded: false
    }
  },
  components: {
    outputSelect,
    pushStatus
  },
  computed: {
    ...mapState({
      CloneDisabled: (state) => state.playout.CloneDisabled,
      // 用户权限
      UserChannelPermission: (state) => state.playout.UserChannelPermission
    })
  },
  created () {
    this.InitMediaServers()
  },
  methods: {
    // 初始化Media服务
    async InitMediaServers () {
      const { protocol } = window.location
      const MaxSharingNums = await this.getMaxSharingNums()
      loadMediaJs(async () => {
        if (!window.mediaObj) return
        const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
        const loginUrl = `${urlInfo.newUserServiceUrl}/?url=${urlInfo.playoutUrl}&serviceName=${urlInfo.playoutServerName}`
        mediaObj.loginUrl = loginUrl
        mediaObj.platform = 'Playout' // 集成项目Commentator、Playout
        mediaObj.shareModule = 'Studio'
        mediaObj.page = 'Channel'
        const ConfigNum = urlInfo.mediaControl && urlInfo.mediaControl.maxSharingNums || 3
        mediaObj.maxSharingNums = MaxSharingNums.status ? MaxSharingNums.num : ConfigNum
        mediaObj.supportPlatform = urlInfo.mediaControl && urlInfo.mediaControl.demandPlatform || 'Y,F,Z,Twitter,O,T,K,Grid,HLS,ISSP,PROMPEG,SRT,ZiXi'
        // urlInfo.mediaControl && urlInfo.mediaControl.demandPlatform ||
        mediaObj.useTemplate = this.from !== 'selectList'
        mediaObj.initOpenWebsocket = this.from === 'pushStatus'
        mediaObj.ignoreGridLimit = true
        // mediaObj.outputMode = 'operateOnly'
        mediaObj.checkPushError = true
        mediaObj.controlAudioChannel = false
        if (this.from == 'header' && this.UserChannelPermission == 5) {
          mediaObj.outputMode = 'operateOnly'
        }
        // mediaObj.supportLangCode = true
        if (this.ProgramItem) {
          const peerId = this.ProgramItem.rid.toUpperCase()
          const domainPrefix = urlInfo.domainPrefix ? urlInfo.domainPrefix : ''
          const url = `${domainPrefix}${peerId}.tvustream.com`
          this.$store.state.mediaInitParams.programInfo.domain = url
        }
        if (this.ProgramItem && this.ProgramItem.shared) {
          const obj = await this.getMembers()
          if (obj.ownerId != '' && obj.currentUserId != '' && obj.userIdList.length) {
            mediaObj.ownerId = obj.ownerId
            mediaObj.currentUserId = obj.currentUserId
            mediaObj.userIdList = obj.userIdList
          }
        } else {
          mediaObj.ownerId = ''
          mediaObj.currentUserId = ''
          mediaObj.userIdList = []
        }
        const obj = {
          type: this.from == 'selectList' || this.from == 'pushStatus' ? '' : 'OutputSetting',
          changeType: 'showOrHide',
          domId: 'mediaOutputList'
        }
        setTimeout(() => {
          if (this.from == 'header' && this.CloneDisabled.PlugFlow) {
            mediaObj.rId = ''
          } else {
            mediaObj.rId = this.ProgramItem && this.ProgramItem.rid.toLowerCase()
          }
          mediaObj.programId = this.ProgramItem && this.ProgramItem.ProgramId.toLowerCase()
          this.$emit('closeLoading')
          if (this.from !== 'selectList') {
            mediaObj.shareToggle = true
          }
          SM.__proto__.JumpMediaJs(obj)
          this.mediaLoaded = true
        }, 1000)
      })
    },
    async getMaxSharingNums () {
      const MaxSharingNums = {
        status: 0,
        num: 0
      }
      await this.axios
        .post(Outil.getUrl('/channelManage/listFeatureByFeatureName'),
          {
            logicType: 2,
            logicId: this.ProgramItem.ProgramId,
            featureName: 'output'
          })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const result = res.data.result
            MaxSharingNums.status = result.status
            const num = Number(result.featureValue)
            MaxSharingNums.num = num || 0
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
      return MaxSharingNums
    },
    // 账号选择
    AccountSelectInfo (val) {
      this.$emit('AccountSelectInfo', val)
    },
    async getMembers () {
      const obj = {
        currentUserId: localStorage.getItem('userId'),
        ownerId: this.ProgramItem.ownerUserId,
        userIdList: []
      }
      await this.axios.post(Outil.getUrl('/programTeamMember/listMember'), {
        programId: this.ProgramItem.ProgramId
      }).then((res) => {
        const result = res.data.result
        if (res.data.errorCode == '0x0') {
          result.forEach((item) => {
            obj.userIdList.push(item.userId)
          })
        }
      }).catch(() => {})
      return obj
    }
  }
}
</script>
